

























import { Component, Vue } from 'vue-property-decorator';
import { getProcess } from "@/req/homes";

@Component({
  components: {}
})
export default class Home extends Vue {
  public config = {
    step: 1,
    speed: 35,
    num: 0
  }
  public processList = [];
  // public timer: any = null;
  // public mouseenter() {
  //   clearInterval(this.timer)
  //   this.timer = null
  // }
  // public mouseleave() {
  //   const Timeline: any = document.querySelector('.Timeline');
  //   this.timer = setInterval(() => {
  //     this.config.num = this.config.num + this.config.step;
  //     if (Timeline.clientHeight - this.config.num <= Timeline.clientHeight / 2) {
  //       this.config.num = 0
  //     }
  //   }, this.config.speed)
  //   if (this.processList.length < 5) {
  //     clearInterval(this.timer)
  //   }
  // }
  /**
   * 获取服务进程
   */
  public async initProcess() {
    const params = {
      token: this.$fn.cookies.getToken()
    }
    const res = await getProcess(params)
    if (res.code === 200) {
      this.processList = res.data;
      // if (this.processList.length < 5) {
      //   clearInterval(this.timer)
      // }
    }
  }
  public mounted() {
    this.initProcess()
    // const Timeline: any = document.querySelector('.Timeline');
    // this.timer = setInterval(() => {
    //   this.config.num = this.config.num + this.config.step;
    //   if (Timeline.clientHeight - this.config.num <= Timeline.clientHeight / 2) {
    //     this.config.num = 0
    //   }
    // }, this.config.speed)
    // this.$once('hook:beforeDestroy', () => {
    //   clearInterval(this.timer)
    //   this.timer = null
    // })
  }
}
